"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[129],{

/***/ 2129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ charge_location_ChargeLocation; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
// EXTERNAL MODULE: ./components/base/button/Button.tsx
var Button = __webpack_require__(5500);
// EXTERNAL MODULE: ./components/base/image/Image.tsx
var Image = __webpack_require__(4297);
// EXTERNAL MODULE: ./components/base/icon/Icon.tsx
var Icon = __webpack_require__(6653);
// EXTERNAL MODULE: ./services/http/wap/query/endpoints.ts
var endpoints = __webpack_require__(97);
// EXTERNAL MODULE: ./services/http/wap/query/mappers.ts
var mappers = __webpack_require__(9278);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(7054);
;// CONCATENATED MODULE: ./components/widgets/charge-location/Map.tsx



var containerStyle = {
    width: '100%',
    height: '100vh'
};
var clusterStyles = [
    {
        textColor: '#FFFFFF',
        url: 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/mc-pin-icon1.png',
        height: 60,
        width: 60,
        textSize: 16
    }, 
];
var clustererOptions = {
    styles: clusterStyles
};
var Map = function(param) {
    var apiKey = param.apiKey, data = param.data, onMarkerSelect = param.onMarkerSelect, center = param.center, mapRef = param.mapRef, setMarkerInfo = param.setMarkerInfo, activeMarker = param.activeMarker;
    var ref = (0,react.useState)(-1), selectedMarker = ref[0], setSelectedMarker = ref[1];
    var handleMarkerClick = function(marker, index) {
        if (mapRef.current) {
            var newCenter = {
                lat: Number(marker.lat),
                lng: Number(marker.lng)
            };
            mapRef.current.panTo(newCenter);
            mapRef.current.setZoom(15);
            onMarkerSelect(marker, index);
            if (selectedMarker === index) {
                setSelectedMarker(-1);
                setMarkerInfo(null);
            } else {
                setSelectedMarker(index);
                setMarkerInfo(marker);
            }
        }
    };
    var getMarkerOptions = function(marker, index) {
        var isSelected = activeMarker === index;
        var isAC = marker.chargingType.title === 'AC';
        var markerUrl;
        if (isAC) {
            markerUrl = isSelected ? 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/map-pin-blue-selected.svg' : 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/map-pin-blue.svg';
        } else {
            markerUrl = isSelected ? 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/map-pin-dc-selected.svg' : 'https://minio.wapbukafamedya.com/storage/Root/evc-charge/map-pin-dc.svg';
        }
        var markerOptions = {
            icon: {
                url: markerUrl,
                scaledSize: isSelected ? new window.google.maps.Size(72, 48) : new window.google.maps.Size(58, 36)
            }
        };
        return markerOptions;
    };
    if (!apiKey) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "API Key giriniz..."
        }));
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LoadScript */.KJ, {
            googleMapsApiKey: apiKey,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* GoogleMap */.b6, {
                mapContainerStyle: containerStyle,
                center: center,
                zoom: 6,
                onLoad: function(map) {
                    mapRef.current = map;
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MarkerClusterer */.XL, {
                    options: clustererOptions,
                    children: function(clusterer) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: data === null || data === void 0 ? void 0 : data.map(function(marker, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
                                    position: {
                                        lat: Number(marker.lat),
                                        lng: Number(marker.lng)
                                    },
                                    clusterer: clusterer,
                                    options: getMarkerOptions(marker, index),
                                    onClick: function() {
                                        return handleMarkerClick(marker, index);
                                    }
                                }, index);
                            })
                        }));
                    }
                })
            })
        }));
    }
};
/* harmony default export */ var charge_location_Map = (Map);

;// CONCATENATED MODULE: ./components/widgets/charge-location/constants.ts
var LOCATION_MAPPING = [
    {
        name: 'title',
        path: 'baslik',
        type: 'query'
    },
    {
        name: 'location',
        path: 'lokasyon',
        type: 'query'
    },
    {
        name: 'lat',
        path: 'latitude',
        type: 'query'
    },
    {
        name: 'lng',
        path: 'longitude',
        type: 'query'
    },
    {
        name: 'address',
        path: 'adres',
        type: 'query'
    },
    {
        name: 'directions',
        path: 'adresTarifi',
        type: 'query'
    },
    {
        name: 'chargingType',
        path: 'sarjTurleri',
        type: 'query',
        children: [
            {
                name: 'title',
                path: 'sarjTurleri.baslik',
                type: 'query'
            },
            {
                name: 'icon',
                path: 'sarjTurleri.icon',
                type: 'query'
            }, 
        ]
    }, 
];

;// CONCATENATED MODULE: ./components/widgets/charge-location/ChargeLocation.tsx














function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ChargeLocation = function(param1) {
    var title1 = param1.title, apiKey = param1.apiKey, chargingTypes = param1.chargingTypes;
    var app = (0,contexts_app/* useApp */.qD)();
    var ref = (0,react.useState)(), filterData = ref[0], setFilterData = ref[1];
    var ref1 = (0,react.useState)(null), markerInfo = ref1[0], setMarkerInfo = ref1[1];
    var ref2 = (0,react.useState)(false), markerSticky = ref2[0], setMarkerSticky = ref2[1];
    var ref3 = (0,react.useState)(-1), activeMarker = ref3[0], setActiveMarker = ref3[1];
    var ref4 = (0,react.useState)({
        title: '',
        location: '',
        charge: ''
    }), queryParams = ref4[0], setQueryParams = ref4[1];
    var mapRef = (0,react.useRef)(null);
    var filterHeadRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(0), filterHead = ref5[0], setFilterHead = ref5[1];
    var defaultCenter = {
        lat: 39.1393768,
        lng: 34.2334807
    };
    var ref6 = (0,react.useState)(defaultCenter), center = ref6[0], setCenter = ref6[1];
    (0,react.useEffect)(function() {
        if (filterHeadRef.current) {
            setFilterHead(filterHeadRef.current.clientHeight);
        }
    }, [
        filterHead
    ]);
    var handleMarkerSelection = lodash_default().debounce(function(marker, index) {
        if (activeMarker === index && marker !== null) {
            setActiveMarker(-1);
            setMarkerInfo(null);
            setMarkerSticky(false);
            setCenter(defaultCenter);
            if (mapRef.current) {
                mapRef.current.setZoom(6);
            }
        } else {
            setMarkerSticky(true);
            setActiveMarker(index);
            setMarkerInfo(marker);
            if (mapRef.current) {
                mapRef.current.setZoom(15);
                mapRef.current.panTo({
                    lat: Number(marker.lat),
                    lng: Number(marker.lng)
                });
            }
        }
    }, 300);
    var getParamsAsQuery = function(params) {
        var searchParams = new URLSearchParams();
        searchParams.set('pageSize', '20');
        if (Object.values(params).find(function(param) {
            return param;
        })) {
            if (params.title) {
                searchParams.set('title', params.title);
            }
            if (params.location) {
                searchParams.set('location', params.location);
            }
            if (params.charge) {
                searchParams.set('charge', params.charge);
            }
        }
        return searchParams.toString();
    };
    var getLocations = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(queryString) {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return endpoints/* run */.K(app.environment, {
                            name: 'get-app-sarj-istasyonlari',
                            language: app.language,
                            query: queryString
                        });
                    case 3:
                        response = _ctx.sent;
                        if (response) {
                            data = (0,mappers/* mapQuery */.w)(response.data, LOCATION_MAPPING);
                            setFilterData(data);
                        }
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(queryString) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        getLocations('');
    }, [
        getLocations
    ]);
    var handleTextfieldBlur = lodash_default().debounce(function(e) {
        var value = e.target.value;
        setQueryParams(function(prevState) {
            return _objectSpread({}, prevState, {
                title: value,
                location: value
            });
        });
    }, 300);
    var handleClick = lodash_default().debounce(function(title) {
        if (queryParams.charge === title) {
            setQueryParams(function(prevState) {
                return _objectSpread({}, prevState, {
                    charge: ''
                });
            });
        } else {
            setQueryParams(function(prevState) {
                return _objectSpread({}, prevState, {
                    charge: title
                });
            });
        }
    }, 300);
    var handleInfo = function() {
        setMarkerSticky(!markerSticky);
    };
    (0,react.useEffect)(function() {
        var queryString = getParamsAsQuery(queryParams);
        getLocations(queryString);
    }, [
        getLocations,
        queryParams
    ]);
    var renderTranslatedText = function(item) {
        var isActiveAC = queryParams.charge === 'AC';
        var isActiveDC = queryParams.charge === 'DC';
        switch(item.title){
            case 'AC':
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    onClick: function() {
                        return handleClick(item.title);
                    },
                    className: (0,functions.classnames)('button--ac', isActiveAC && 'button--active'),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, item.icon, {
                                alt: item.title
                            }))
                        }),
                        app.settings.translations['ac-charge']
                    ]
                }));
            case 'DC':
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    onClick: function() {
                        return handleClick(item.title);
                    },
                    className: (0,functions.classnames)('button--dc', isActiveDC && 'button--active'),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, item.icon, {
                                alt: item.title
                            }))
                        }),
                        app.settings.translations['dc-charge']
                    ]
                }));
            default:
                return item.title;
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "charge-locations",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
            size: "fluid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Row */.X2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                        xs: {
                            size: 12
                        },
                        sm: {
                            size: 12
                        },
                        md: {
                            size: 12
                        },
                        lg: {
                            size: 4
                        },
                        xl: {
                            size: 4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "charge-locations-sidebar",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    ref: filterHeadRef,
                                    className: "charge-locations-head",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "charge-locations-title",
                                            children: title1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "chrage-locations-filter",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "search field",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: "Konuma veya isme g\xf6re arama yapın",
                                                        onChange: handleTextfieldBlur
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "energy-types field",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: chargingTypes === null || chargingTypes === void 0 ? void 0 : chargingTypes.map(function(item, index) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                                                children: renderTranslatedText(item)
                                                            }, index);
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "charge-locations-list",
                                    style: {
                                        height: "calc(100% - ".concat(filterHead, "px)")
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "in",
                                        children: filterData === null || filterData === void 0 ? void 0 : filterData.map(function(item, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                    className: (0,functions.classnames)(activeMarker === index && 'button--active', item.chargingType.title === 'AC' && 'button--ac', item.chargingType.title === 'DC' && 'button--dc'),
                                                    onClick: function() {
                                                        return handleMarkerSelection(item, index);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, item.chargingType.icon, {
                                                                alt: item.chargingType.title
                                                            }))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "desc",
                                                            children: [
                                                                item.title,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: item.location
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,functions.classnames)('charge-locations-selected', markerSticky && 'charge-locations-selected--active'),
                                    children: markerInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,functions.classnames)('type', markerInfo.chargingType.title === 'AC' ? 'type--ac' : 'type--dc'),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, markerInfo.chargingType.icon, {
                                                            alt: markerInfo.chargingType.title
                                                        }))
                                                    }),
                                                    markerInfo.chargingType.title === 'AC' ? app.settings.translations['ac-charge'] : app.settings.translations['dc-charge']
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "title",
                                                children: markerInfo.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                dangerouslySetInnerHTML: {
                                                    __html: markerInfo.address
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                dangerouslySetInnerHTML: {
                                                    __html: markerInfo.directions
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                onClick: handleInfo,
                                                className: (0,functions.classnames)('handle-button', !markerSticky && 'handle-button--disable'),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    name: "icon-arrow-left"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                        xs: {
                            size: 12
                        },
                        sm: {
                            size: 12
                        },
                        md: {
                            size: 12
                        },
                        lg: {
                            size: 8
                        },
                        xl: {
                            size: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "charge-locations-map",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charge_location_Map, {
                                apiKey: apiKey,
                                data: filterData,
                                onMarkerSelect: handleMarkerSelection,
                                center: center,
                                mapRef: mapRef,
                                setMarkerInfo: setMarkerInfo,
                                activeMarker: activeMarker
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var charge_location_ChargeLocation = (ChargeLocation);

;// CONCATENATED MODULE: ./components/widgets/charge-location/index.ts



/***/ }),

/***/ 97:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ run; },
/* harmony export */   "O": function() { return /* binding */ runForm; }
/* harmony export */ });
/* harmony import */ var _http__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5172);

var run = function(environment, params) {
    return (0,_http__WEBPACK_IMPORTED_MODULE_0__/* .request */ .W)(environment, {
        method: 'get',
        url: "/queries/".concat(params.language, "/").concat(params.name, "/run?").concat(params.query || '')
    });
};
var runForm = function(environment, params, data) {
    return (0,_http__WEBPACK_IMPORTED_MODULE_0__/* .request */ .W)(environment, {
        method: 'post',
        url: "/queries/".concat(params.language, "/").concat(params.name, "/run?").concat(params.query || ''),
        data: data
    });
};


/***/ }),

/***/ 9278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ mapQuery; }
/* harmony export */ });
/* harmony import */ var dot_prop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6833);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var getReferenceValue = function(param, refs) {
    var type = param.type, ref = param.ref;
    if (ref) {
        var reference = refs.find(function(item) {
            return item.id === ref;
        });
        if (reference) {
            var types = [
                'image',
                'file',
                'video',
                'link'
            ];
            if (types.includes(type)) {
                return reference.path;
            } else {
                return reference;
            }
        }
    }
    return null;
};
var getReference = function(tree, refs) {
    if (tree) {
        if ('type' in tree && 'ref' in tree) {
            tree = getReferenceValue(tree, refs);
        } else {
            for(var key in tree){
                var branch = tree[key];
                if (branch) {
                    if (Array.isArray(branch)) {
                        tree[key] = branch.map(function(leaf) {
                            return getReference(leaf, refs);
                        });
                    } else if (typeof branch === 'object') {
                        if ('type' in branch) {
                            if (branch.type === 'static') {
                                tree[key] = branch.label;
                            } else {
                                if ('ref' in branch) {
                                    tree[key] = getReferenceValue(branch, refs);
                                }
                            }
                        } else {
                            tree[key] = getReference(branch, refs);
                        }
                    } else {
                        tree[key] = branch;
                    }
                }
            }
        }
    }
    return tree;
};
var getQueryMapping = function(item, mappings) {
    var value = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = mappings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var mapping = _step.value;
            var property = (0,dot_prop__WEBPACK_IMPORTED_MODULE_0__/* .getProperty */ .$s)(item, mapping.path);
            if (property) {
                // console.log({ property, mappings })
                if (typeof property === 'object') {
                    if (Array.isArray(property)) {
                        var data = [];
                        var properties = property;
                        var mappings1 = mapping.children || [];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = properties[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var prop = _step1.value;
                                var result = getQueryMapping(prop, mappings1.map(function(child) {
                                    return _objectSpread({}, child, {
                                        path: child.path.replace("".concat(mapping.path, "."), '')
                                    });
                                }));
                                data.push(result);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        value[mapping.name] = data;
                    } else {
                        if (property['value'] && property['refs']) {
                            var data1 = getReference(property['value'], property['refs']);
                            value[mapping.name] = data1;
                        } else {
                            var mappings2 = mapping.children || [];
                            if (mappings2.length) {
                                value[mapping.name] = getQueryMapping(item, mappings2);
                            } else {
                                value[mapping.name] = property;
                            }
                        }
                    }
                } else {
                    if (mapping.type === 'link') {
                        value[mapping.name] = {
                            href: property
                        };
                    } else {
                        value[mapping.name] = property;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return value;
};
var mapQuery = function(query, mappings) {
    if (Array.isArray(query)) {
        var data = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                data.push(getQueryMapping(item, mappings));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return data;
    } else {
        return getQueryMapping(query, mappings);
    }
};


/***/ }),

/***/ 6833:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$s": function() { return /* binding */ getProperty; }
/* harmony export */ });
/* unused harmony exports setProperty, deleteProperty, hasProperty, escapePath, deepKeys */
const isObject = value => {
	const type = typeof value;
	return value !== null && (type === 'object' || type === 'function');
};

const disallowedKeys = new Set([
	'__proto__',
	'prototype',
	'constructor',
]);

const digits = new Set('0123456789');

function getPathSegments(path) {
	const parts = [];
	let currentSegment = '';
	let currentPart = 'start';
	let isIgnoring = false;

	for (const character of path) {
		switch (character) {
			case '\\':
				if (currentPart === 'index') {
					throw new Error('Invalid character in an index');
				}

				if (currentPart === 'indexEnd') {
					throw new Error('Invalid character after an index');
				}

				if (isIgnoring) {
					currentSegment += character;
				}

				currentPart = 'property';
				isIgnoring = !isIgnoring;
				break;

			case '.':
				if (currentPart === 'index') {
					throw new Error('Invalid character in an index');
				}

				if (currentPart === 'indexEnd') {
					currentPart = 'property';
					break;
				}

				if (isIgnoring) {
					isIgnoring = false;
					currentSegment += character;
					break;
				}

				if (disallowedKeys.has(currentSegment)) {
					return [];
				}

				parts.push(currentSegment);
				currentSegment = '';
				currentPart = 'property';
				break;

			case '[':
				if (currentPart === 'index') {
					throw new Error('Invalid character in an index');
				}

				if (currentPart === 'indexEnd') {
					currentPart = 'index';
					break;
				}

				if (isIgnoring) {
					isIgnoring = false;
					currentSegment += character;
					break;
				}

				if (currentPart === 'property') {
					if (disallowedKeys.has(currentSegment)) {
						return [];
					}

					parts.push(currentSegment);
					currentSegment = '';
				}

				currentPart = 'index';
				break;

			case ']':
				if (currentPart === 'index') {
					parts.push(Number.parseInt(currentSegment, 10));
					currentSegment = '';
					currentPart = 'indexEnd';
					break;
				}

				if (currentPart === 'indexEnd') {
					throw new Error('Invalid character after an index');
				}

				// Falls through

			default:
				if (currentPart === 'index' && !digits.has(character)) {
					throw new Error('Invalid character in an index');
				}

				if (currentPart === 'indexEnd') {
					throw new Error('Invalid character after an index');
				}

				if (currentPart === 'start') {
					currentPart = 'property';
				}

				if (isIgnoring) {
					isIgnoring = false;
					currentSegment += '\\';
				}

				currentSegment += character;
		}
	}

	if (isIgnoring) {
		currentSegment += '\\';
	}

	switch (currentPart) {
		case 'property': {
			if (disallowedKeys.has(currentSegment)) {
				return [];
			}

			parts.push(currentSegment);

			break;
		}

		case 'index': {
			throw new Error('Index was not closed');
		}

		case 'start': {
			parts.push('');

			break;
		}
	// No default
	}

	return parts;
}

function isStringIndex(object, key) {
	if (typeof key !== 'number' && Array.isArray(object)) {
		const index = Number.parseInt(key, 10);
		return Number.isInteger(index) && object[index] === object[key];
	}

	return false;
}

function assertNotStringIndex(object, key) {
	if (isStringIndex(object, key)) {
		throw new Error('Cannot use string index');
	}
}

function getProperty(object, path, value) {
	if (!isObject(object) || typeof path !== 'string') {
		return value === undefined ? object : value;
	}

	const pathArray = getPathSegments(path);
	if (pathArray.length === 0) {
		return value;
	}

	for (let index = 0; index < pathArray.length; index++) {
		const key = pathArray[index];

		if (isStringIndex(object, key)) {
			object = index === pathArray.length - 1 ? undefined : null;
		} else {
			object = object[key];
		}

		if (object === undefined || object === null) {
			// `object` is either `undefined` or `null` so we want to stop the loop, and
			// if this is not the last bit of the path, and
			// if it didn't return `undefined`
			// it would return `null` if `object` is `null`
			// but we want `get({foo: null}, 'foo.bar')` to equal `undefined`, or the supplied value, not `null`
			if (index !== pathArray.length - 1) {
				return value;
			}

			break;
		}
	}

	return object === undefined ? value : object;
}

function setProperty(object, path, value) {
	if (!isObject(object) || typeof path !== 'string') {
		return object;
	}

	const root = object;
	const pathArray = getPathSegments(path);

	for (let index = 0; index < pathArray.length; index++) {
		const key = pathArray[index];

		assertNotStringIndex(object, key);

		if (index === pathArray.length - 1) {
			object[key] = value;
		} else if (!isObject(object[key])) {
			object[key] = typeof pathArray[index + 1] === 'number' ? [] : {};
		}

		object = object[key];
	}

	return root;
}

function deleteProperty(object, path) {
	if (!isObject(object) || typeof path !== 'string') {
		return false;
	}

	const pathArray = getPathSegments(path);

	for (let index = 0; index < pathArray.length; index++) {
		const key = pathArray[index];

		assertNotStringIndex(object, key);

		if (index === pathArray.length - 1) {
			delete object[key];
			return true;
		}

		object = object[key];

		if (!isObject(object)) {
			return false;
		}
	}
}

function hasProperty(object, path) {
	if (!isObject(object) || typeof path !== 'string') {
		return false;
	}

	const pathArray = getPathSegments(path);
	if (pathArray.length === 0) {
		return false;
	}

	for (const key of pathArray) {
		if (!isObject(object) || !(key in object) || isStringIndex(object, key)) {
			return false;
		}

		object = object[key];
	}

	return true;
}

function escapePath(path) {
	if (typeof path !== 'string') {
		throw new TypeError('Expected a string');
	}

	return path.replace(/[\\.[]/g, '\\$&');
}

// The keys returned by Object.entries() for arrays are strings
function entries(value) {
	if (Array.isArray(value)) {
		return value.map((value, index) => [index, value]);
	}

	return Object.entries(value);
}

function stringifyPath(pathSegments) {
	let result = '';

	for (let [index, segment] of entries(pathSegments)) {
		if (typeof segment === 'number') {
			result += `[${segment}]`;
		} else {
			segment = escapePath(segment);
			result += index === 0 ? segment : `.${segment}`;
		}
	}

	return result;
}

function * deepKeysIterator(object, currentPath = []) {
	if (!isObject(object)) {
		if (currentPath.length > 0) {
			yield stringifyPath(currentPath);
		}

		return;
	}

	for (const [key, value] of entries(object)) {
		yield * deepKeysIterator(value, [...currentPath, key]);
	}
}

function deepKeys(object) {
	return [...deepKeysIterator(object)];
}


/***/ })

}]);